const StoreManager = require("../storeManager")
const debounce = require("../../helpers/debounce")
const { streamData, waitForStream } = require("../../helpers/streaming")

globalThis.debugWorkspace = false

// WARNING: _store arg to delete
module.exports = function (_store, projectUid, appIndex, licenceUid) {
  const {
    socket,
    store,
    createWorker
  } = globalThis

  /**
   * @param {number} downloadedBytes
   * @param {number} streamedBytes
   * @param {{
   *  streamId: string,
   *  packetId: string,
   *  chunkNum: number,
   *  chunk: Buffer,
   *  streamedBytes: number
   * }} packet
   */
  const streamTracker = (downloadedBytes, streamedBytes, packet) => {
    store.dispatch({
      type: "WORKSPACE_STREAM_PROGRESS",
      projectUid,
      licenceUid,
      streamId: packet.streamId,
      packetId: packet.packetId,
      chunkNum: packet.chunkNum,
      downloadedBytes,
      streamedBytes
    })
  }

  let onUpdated = function (stream) {
    streamData(socket, stream, { tracker: streamTracker }).then(state => {
      if (state.projectUid === projectUid && licenceUid in state.apps) {

        if (globalThis.debugWorkspace) console.log("workspace.updated", state)

        store.dispatch({
          type: "WORKSPACE_UPDATED",
          projectUid,
          licenceUid,
          shared: state.apps[licenceUid].shared,
          users: state.users
        })

        this.updateAll(state.apps[licenceUid].index)
      }
    })
  }

  let onClosing = function (res) {
    if (res.uid === projectUid) {
      store.dispatch({
        type: "WORKSPACE_CLOSING",
        uid: projectUid,
        inactivity: res.inactivity
      })
    }
  }

  // create the manager
  let manager = new StoreManager({
    createWorker,
    readIndex() {
      return store.getState().workspaces[projectUid][licenceUid].index
    },

    writeIndex(next) {
      store.dispatch({
        type: 'WORKSPACE_WRITE_INDEX',
        projectUid,
        licenceUid,
        index: next
      })
    },

    updateAllStore({
      toFetch,
      toClean
    }) {
      if (Object.keys(toClean).length) {
        store.dispatch({
          type: "WORKSPACE_DELETE_ALL_ELEMENTS",
          projectUid,
          licenceUid,
          toClean
        })
      }

      if (toFetch.length) {
        Promise.all(toFetch.map(e => {
          return socket.request("workspace.fetchAll", {
            projectUid,
            licenceUid,
            toFetch: e
          }).then(streamUid => waitForStream(socket, streamUid, { tracker: streamTracker })
            .then(elements => [streamUid, elements.filter(e => ![null, undefined].includes(e))])
          )
        })).then(array => {
          store.dispatch({
            type: 'WORKSPACE_UPDATE_ALL_ELEMENTS',
            projectUid,
            licenceUid,
            elements: array.map(([_, elements]) => elements).flat()
          })
          store.dispatch({
            type: "WORKSPACE_CLEAR_STREAM",
            projectUid,
            licenceUid,
            streamIds: array.map(([streamUid]) => streamUid)
          })
        }).catch(console.error)
      }
    },

    onStart(index) {
      // Listen to updates / closing

      if (!socket.listeners("workspace.updated").includes(this.updateListener)) {
        console.log("listening", "workspace.updated");
        socket.on("workspace.updated", this.updateListener)
      } else {
        console.log("already listening", "workspace.updated");
      }

      if (!socket.listeners("workspace.closing").includes(this.closeListener)) {
        console.log("listening", "workspace.closing");
        socket.on("workspace.closing", this.closeListener)
      } else {
        console.log("already listening", "workspace.closing");
      }

      // Initialize the manager
      this.updateAll(index)
      this.started = true
    },

    onClose() {
      socket.removeEventListener("workspace.updated", this.updateListener)
      socket.removeEventListener("workspace.closing", this.closeListener)
      this.started = false
    }
  })

  manager.updateListener = debounce(onUpdated.bind(manager), 250, true, manager)
  manager.closeListener = onClosing.bind(manager)

  manager.start(appIndex)

  return manager
}